<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="card-body row" style="width:100%; margin-left:0px">
        <audience-info-block [audience]="audience" style="width: 100%;"></audience-info-block>
    </div>    
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="dismiss()">Close</button>
</div>